import { useLora, useLoraImages } from "@features/loras/use-loras";
import { useParams } from "react-router-dom";
import { Step1 } from "./step-1";

export const Step1Upgrade = () => {
  const { id } = useParams();
  const { data: lora } = useLora(id || "");
  const { data, isLoading } = useLoraImages(id || "");

  if (!lora || isLoading) {
    return null;
  }

  return (
    <Step1
      upgrade
      initialName={lora.name}
      type={lora.type}
      initialImages={data?.map((a) => ({
        front_id: a.id,
        added_at: a.created_at,
        id: a.id,
        score: a.quality / 100,
        url: a.image_url,
        details: {
          pose: a.pose,
          main_score: a.quality / 100,
          face_count: a.facing_score / 100,
          object: a.category || "object",
          image_hash: a.image_hash,
        },
      }))}
    />
  );
};
